import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { Checkbox } from "./ui/checkbox";
import { Loader2, Layers } from "lucide-react";

export function SecretariatBulkBar({ items, type, action, label, selectedIds, onSelectAll, onBulk, bulkBusy }) {
  const ids = selectedIds(items);
  const allSelected = items.length > 0 && ids.length === items.length;
  return (
    <div
      className="flex items-center justify-between gap-3 flex-wrap bg-secondary/50 border rounded p-3 mb-3"
      data-testid={`bulk-bar-${type}-${action}`}
    >
      <div className="flex items-center gap-3">
        <Checkbox
          checked={allSelected}
          onCheckedChange={(v) => onSelectAll(!!v)}
          data-testid={`select-all-${type}-${action}`}
        />
        <Label className="text-sm">
          {ids.length > 0
            ? `Odabrano: ${ids.length} od ${items.length}`
            : `Odaberite zahtjeve (${items.length} ukupno)`}
        </Label>
      </div>
      <Button
        size="sm"
        onClick={() =>
          onBulk(
            type,
            action === "generate" ? "generate-pdf" : "send",
            ids,
            action === "generate"
              ? `Generirati ${ids.length} rješenja u jednom potezu?`
              : `Poslati ${ids.length} rješenja na zaposlenike i nadređene?`,
          )
        }
        disabled={bulkBusy || ids.length === 0}
        data-testid={`bulk-${action}-${type}`}
      >
        {bulkBusy ? <Loader2 className="w-4 h-4 mr-2 animate-spin"/> : <Layers className="w-4 h-4 mr-2"/>}
        {label}
      </Button>
    </div>
  );
}
